import type { ReactElement } from "react";
import { Cimage } from "../Cimage";
import { Cstretchmodal } from "../Cstretchmodal";
import { IMAGE_PREVIEW_LIGHTBOX_MAX_HEIGHT, IMAGE_PREVIEW_REFERRER_POLICY, } from "./image-preview-constants";
interface CimagepreviewLightboxProps {
    enabled: boolean;
    visible: boolean;
    onClose: () => void;
    src: string;
    alt: string;
    title?: string;
}
export function CimagepreviewLightbox({ enabled, visible, onClose, src, alt, title, }: CimagepreviewLightboxProps): ReactElement | null {
    if (!enabled) {
        return null;
    }
    return (
    <Cstretchmodal dataElScope="Cimagepreview/CimagepreviewLightbox" visible={visible} onClose={onClose}>
      <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
        }}>
        <Cimage src={src} alt={alt} title={title} animation="fadeBlur" showSkeleton={true} objectFit="contain" referrerPolicy={IMAGE_PREVIEW_REFERRER_POLICY} style={{
            maxWidth: "100%",
            maxHeight: IMAGE_PREVIEW_LIGHTBOX_MAX_HEIGHT,
            width: "auto",
            height: "auto",
        }}/>
      </div>
    </Cstretchmodal>
    );
}
